<template>
  <div class="row">
    <div class="col-3">
      <v-subheader>
        Operadora: &nbsp;
        <span v-if="negociacao.operadora && negociacao.operadora.nome">
          {{ negociacao.operadora.nome }}
        </span>
      </v-subheader>
    </div>
    <div class="col-3">
      <v-subheader>Plano: {{ negociacao.plano }}</v-subheader>
    </div>
    <div class="col-3">
      <v-subheader>Tabela: {{ negociacao.tabela }}</v-subheader>
    </div>
    <div class="col-3">
      <v-subheader>Porte: {{ negociacao.porte }}</v-subheader>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    negociacao: {
      default: {},
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.v-subheader {
  margin-top: 0;
  height: 40px;
}
</style>
